import StandardTabPanel from "../../../ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function SubNavigation({
  viewName,
  id,
  parentTab,
  activeTab,
  subtabs = [],
  children,
}) {
  const allTabs = subtabs.map((tab) => ({
    key: tab.key,
    name: tab.name,
    isDisabled: false,
    permission: null,
    href: `/${viewName}/${id}/${parentTab}/${tab.key}`,
  }));

  return (
    <StandardTabPanel
      activeTab={activeTab}
      tabList={allTabs}
      headerTabSx={TAB_STYLES.SUB_TAB.SX}
      headerTabIndicatorSx={TAB_STYLES.SUB_TAB.TAB_INDICATOR_SX}
    >
      <section className="h-[90vh] overflow-hidden p-4">{children}</section>
    </StandardTabPanel>
  );
}
